import { connect } from 'react-redux';

import { SummaryTable } from './SummaryTableWidgetView';
import { form } from '../../../../../common/reducers';

export default connect((state, { id }) => ({ ...form.getElement(state, id) }))(SummaryTable);
